import { observable, action, computed, makeObservable } from 'mobx';
import { BroadcastChannel } from 'broadcast-channel';
import { log } from 'common/utils/logging.util';
import { resetAnalytics } from 'common/utils/client-analytics.util';
import { removeAuthCookie } from 'common/bridges/cookies.bridge';
import { IS_DISONA } from 'common/utils/style.util';
import { LocalStorageKeys } from '../constants/local-storage.constants';
import { LocalStorage } from '../bridges/local-storage.bridge';

class AppStore {
  @observable crossTabsChannel = null;

  @observable accountType =
    LocalStorage.get(LocalStorageKeys.AccountType) || 'Demo';

  @observable initialUrl = null;

  @observable isFeedbackFormOpened = false;

  @observable accountForPasswordChangeForm = null;

  @observable isFeedbackFormInvisible = true;

  @observable presetMasterID = LocalStorage.get(LocalStorageKeys.MasterID);

  @observable lng = 'en';

  @observable initialized = false;

  @observable isI18nextInitiated = false;

  @observable wizardInvestorAccountData = {
    master_account_id:
      Number(LocalStorage.get(LocalStorageKeys.MasterID)) || '',
    termsAndConditions:
      LocalStorage.get(LocalStorageKeys.TermsAndConditions) || false,
    server_code: '',
    account_type: 'investor_real',
    account_currency: 'USD',
  };

  @observable wizardStep = LocalStorage.get(LocalStorageKeys.WizardStep) || 0;

  @observable wizardStepsPassed =
    LocalStorage.get(LocalStorageKeys.WizardStepsPassed) || 0;

  @observable creatingFirstDemoAccount = false;

  constructor() {
    makeObservable(this);
  }

  @computed
  get getAccountType() {
    return this.accountType;
  }

  @action
  setIsI18nextInitiated = (state) => {
    this.isI18nextInitiated = state;
  };

  @action
  setInitialUrl = (val) => {
    this.initialUrl = val;
  };

  @action
  setWizardInvestorAccountData = ({ key, value }) => {
    this.wizardInvestorAccountData[key] = value;
  };

  @action
  setWizardStep = (step) => {
    this.wizardStep = step;
    LocalStorage.set(LocalStorageKeys.WizardStep, step);
  };

  @action setWizardStepsPassed = (step) => {
    this.wizardStepsPassed = step;
    LocalStorage.set(LocalStorageKeys.WizardStepsPassed, step);
  };

  @action setPresetMasterID = (val) => {
    val = Number(val);
    this.presetMasterID = val;
    LocalStorage.set(LocalStorageKeys.MasterID, val);
  };

  @action setLng = (lng) => {
    this.lng = lng;
  };

  @action setFeedbackFormOpened = (value) => {
    this.isFeedbackFormOpened = value;
  };

  @action setFeedbackFormInvisible = (value) => {
    this.isFeedbackFormInvisible = value;
  };

  @action setAccountForPasswordChangeForm = (value) => {
    this.accountForPasswordChangeForm = value;
  };

  @action changeAccountType = (type) => {
    this.accountType = type;
    LocalStorage.set(LocalStorageKeys.AccountType, type);
  };

  @action enableCrossTabsChannel = () => {
    if (!this.crossTabChannel) {
      this.crossTabChannel = new BroadcastChannel('rw_crosstabs');
    }
  };

  @action disableCrossTabsChannel = () => {
    if (this.crossTabChannel) {
      this.crossTabChannel.close();
      this.crossTabChannel = null;
    } else {
      log('[crossTab] not found', 'warn');
    }
  };

  @action enableCloseOnChannelEvent = () => {
    this.enableCrossTabsChannel();
    this.crossTabChannel.onmessage = (msg) => {
      if (msg === 'closetab') {
        window.close();
      }
    };
    log('[crossTab] enabled event', 'warn');
  };

  @action disableCloseOnChannelEvent = () => {
    this.disableCrossTabsChannel();
  };

  @action openTabWithCloseOnRedirectEvent = (url) => {
    window.open(url);
    this.enableCloseOnChannelEvent();
  };

  @action sendCloseCrossTabEvent = () => {
    if (!this.crossTabChannel) this.enableCrossTabsChannel();
    this.crossTabChannel.postMessage('closetab');
    log('[crossTab] sent', 'warn');
  };

  logout = () => {
    resetAnalytics();
    removeAuthCookie();
    sessionStorage.setItem('acc-history-filter-date', '');
    if (IS_DISONA && process.env.REACT_APP_ENVIRONMENT === 'production') {
      window.location.replace('https://disona.com/login');
    } else {
      window.location.replace('/');
    }
  };

  @action setCreatingFirstDemoAccount(state) {
    this.creatingFirstDemoAccount = state;
  }
}

const appStore = new AppStore();

export default appStore;
